import { render, staticRenderFns } from "./regist.vue?vue&type=template&id=3f148c12&scoped=true&"
import script from "./regist.vue?vue&type=script&lang=ts&"
export * from "./regist.vue?vue&type=script&lang=ts&"
import style0 from "./regist.vue?vue&type=style&index=0&id=3f148c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f148c12",
  null
  
)

export default component.exports